import { render } from "./1_body.vue?vue&type=template&id=1355d4f8"
import script from "./1_body.vue?vue&type=script&lang=js"
export * from "./1_body.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__